
<template>
<div>
    <div v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf">
            <div class="row mb-2">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 d-flex justify-content-center">
                        <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                    </div>
                    <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row">
                <div class="col-md-6">
                    <input type="date" v-model="filters.date_1" class="form-control" @input="endofday()">
                    <input type="date" v-model="filters.date_2" class="form-control" @input="endofday()">
                </div>
                <div class="col-md-6">
                    <select v-model="filters.user" class="form-control" @input="endofday()">
                        <option value="" disabled selected>All Staff</option>
                        <option v-for="user in users" :value="user.value" :key="user.value"> {{user.text}} </option>
                    </select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="well">Transaction Report</div>
                <table class="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer Name</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                            <th>Notes</th>
                            <th v-if="$gate.isAdmin() || $gate.isManager()">Action</th>
                            <!-- <th>Cashier</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> STEP - {{transaction.id}} </td>
                            <td> {{transaction.customer}} </td>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable | formatAmount}} </td>
                            <td> {{transaction.discount | formatAmount}} </td>
                            <td> {{transaction.vat | formatAmount}} </td>
                            <td> {{transaction.total | formatAmount}} </td>
                            <td> {{transaction.cashier}} </td>
                            <td> {{transaction.notes}} </td>
                            <td v-if="$gate.isAdmin() || $gate.isManager()">
                                <!-- <template v-if="transaction.category != 'Product'">
                                    <button class="btn btn-danger" @click="canceled(transaction)">Cancel</button>
                                </template>
                                <template v-else>
                                    <button class="btn btn-warning" @click="refund(transaction)">Refund</button>
                                </template> -->
                            </td>
                            <!-- <td> {{transaction.cashier}} </td> -->
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{taxable | formatAmount}}  </strong></td>
                            <td> <strong> {{discount | formatAmount}}  </strong></td>
                            <td> <strong> {{vat| formatAmount}}  </strong></td>
                            <td> <strong> {{total | formatAmount}}  </strong></td>
                        </tr>
                    </tfoot>
                </table>

                <template v-if="transactionsCancelled.length > 0">
                    <div class="well" >Cancelled Transaction Report</div>
                    <table class="table table-bordered table-responsive" >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Transaction Number</th>
                                <th>Payment Method</th>
                                <th>Item</th>
                                <th>Status</th>
                                <th>Taxable</th>
                                <th>Discount</th>
                                <th>VAT 5%</th>
                                <th>Total</th>
                                <th>Notes</th>
                                <!-- <th>Cashier</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="transaction in transactionsCancelled" :key="transaction.id">
                                <td> {{transaction.date}} </td>
                                <td> STEP - {{transaction.id}} </td>
                                <td> {{transaction.payment}} </td>
                                <td> {{transaction.quantity}} </td>
                                <td> {{transaction.status}} </td>
                                <td> {{transaction.taxable | formatAmount}} </td>
                                <td> {{transaction.discount | formatAmount}} </td>
                                <td> {{transaction.vat | formatAmount}} </td>
                                <td> {{transaction.total | formatAmount}} </td>
                                <td> {{transaction.notes}}</td>
                                <!-- <td> {{transaction.cashier}} </td> -->
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td> <strong> {{taxablecancelled | formatAmount}}  </strong></td>
                                <td> <strong> {{discountcancelled | formatAmount}}  </strong></td>
                                <td> <strong> {{vatcancelled | formatAmount}}  </strong></td>
                                <td> <strong> {{totalcancelled | formatAmount}}  </strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </template>

                <template v-if="transactionsRefunded.length > 0">
                    <div class="well" >Refunded Transaction Report</div>
                    <table class="table table-bordered table-responsive" >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Transaction Number</th>
                                <th>Payment Method</th>
                                <th>Item</th>
                                <th>Status</th>
                                <th>Taxable</th>
                                <th>Discount</th>
                                <th>VAT 5%</th>
                                <th>Total</th>
                                <th>Notes</th>

                                <!-- <th>Cashier</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="transaction in transactionsRefunded" :key="transaction.id">
                                <td> {{transaction.date}} </td>
                                <td> STEP - {{transaction.id}} </td>
                                <td> {{transaction.payment}} </td>
                                <td> {{transaction.quantity}} </td>
                                <td> {{transaction.status}} </td>
                                <td> {{transaction.taxable | formatAmount}} </td>
                                <td> {{transaction.discount | formatAmount}} </td>
                                <td> {{transaction.vat | formatAmount}} </td>
                                <td> {{transaction.total | formatAmount}} </td>
                                <td> {{transaction.notes }} </td>
                                <!-- <td> {{transaction.cashier}} </td> -->
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td> <strong> {{taxablerefunded | formatAmount}}  </strong></td>
                                <td> <strong> {{discountrefunded | formatAmount}}  </strong></td>
                                <td> <strong> {{vatrefunded | formatAmount}}  </strong></td>
                                <td> <strong> {{totalrefunded | formatAmount}}  </strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </template>
            </div>
        </div>
        <div class="col-md-12" id="print">
                <button class="btn btn-success hidden-print" @click="print"><i class="fa fa-print"></i></button>
                <button class="btn btn-success hidden-print" @click="pdf"><i class="fa fa-file"></i></button>
                <excel
                        class = "btn btn-info"
                        :data = "transactions"
                        type  = "xls"
                        name = "Transaction_Report.xls">
                        Download Excel
                </excel>
        </div>
    </div>
    <div class="row" v-else>
        <notfound></notfound>
    </div>

</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import Swal from 'sweetalert2'
    window.Swal = Swal
    const toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });
import JsonExcel from 'vue-json-excel';
export default {
    components: {
        excel: JsonExcel
    },
    data(){
        return {
            transactions:[],
            transactionsCancelled: [],
            transactionsRefunded: [],
            users:[],
            filters: {
                date_1: new Date().toISOString().substr(0, 10),
                date_2: new Date().toISOString().substr(0, 10),
                user_id: this.$root.id,
                name: this.$root.staffname,
                draw: 0,
                user: ''
            },


        }
    },
    created(){
        this.endofday();
        this.getusers();
    },
    methods: {
        endofday(url = './api/Report/transaction') {
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                console.log(result.data)
                this.transactions = result.data.transaction
                this.transactionsCancelled = result.data.transactioncancelled
                this.transactionsRefunded = result.data.transactionrefunded
            }).catch((err) => {
                console.log(err)
            });
        },
        getusers() {
            axios
            .get('./api/Report/users')
            .then((result) => {
                console.log(result.data)
                this.users = result.data.users
            }).catch((err) => {
                console.log(err)
            });
        },
        print(){
            var printButton = document.getElementById("print")
            printButton.style.visibility = 'hidden'
            // var divPrint = this.$refs.print

            // window.document.write(divPrint.innerHTML)
            window.print()
            
            // Use afterprint event to restore button visibility after print dialog closes
            window.onafterprint = () => {
                printButton.style.visibility = 'visible'
                window.onafterprint = null
            }
        },
        canceled(transaction) {
            Swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Cancel it!'
                }).then((result) => {
                if (result.value) {
                    Swal(
                        'Cancel!',
                        'Your file has been cancelled.',
                        'success',
                        axios
                        .post('./api/Report/transaction/cancelled', {
                            id: transaction.id
                        })
                        .then((result) => {
                            console.log(result)
                            this.endofday()
                        }).catch((err) => {
                            console.log(err)
                        }),

                    )
                }
            })

        },
        refund(transaction) {
            Swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Refund it!'
                }).then((result) => {
                if (result.value) {
                    Swal(
                        'Refund!',
                        'Your file has been refunded.',
                        'success',
                        axios
                        .post('./api/Report/transaction/refunded', {
                            id: transaction.id
                        })
                        .then((result) => {
                            console.log(result)
                            this.endofday()
                        }).catch((err) => {
                            console.log(err)
                        }),

                    )
                }
            })
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'Transaction Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        }
    },
    computed: {
        taxable() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discount() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vat() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        total() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },

        taxablecancelled() {
            return this.transactionsCancelled.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discountcancelled() {
            return this.transactionsCancelled.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vatcancelled() {
            return this.transactionsCancelled.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        totalcancelled() {
            return this.transactionsCancelled.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },

        taxablerefunded() {
            return this.transactionsRefunded.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discountrefunded() {
            return this.transactionsRefunded.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vatrefunded() {
            return this.transactionsRefunded.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        totalrefunded() {
            return this.transactionsRefunded.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        }

    },
    filters:{
        formatAmount: function (value) {
            return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
}
</script>

<style scoped>
@media print {
    @page {
        size: landscape;
        margin: 0.5cm;
    }
    
    body {
        font-size: 9px;
    }
    
    #pdf {
        width: 100%;
        overflow: visible;
    }
    
    .table {
        width: 100% !important;
        font-size: 8px;
        table-layout: auto;
        border-collapse: collapse;
    }
    
    .table th,
    .table td {
        padding: 3px 4px !important;
        white-space: normal !important;
        word-wrap: break-word;
        overflow-wrap: break-word;
        vertical-align: top;
    }
    
    /* Notes column: 12th in main table, 10th in cancelled/refunded tables */
    .table thead tr th:nth-child(12),
    .table tbody tr td:nth-child(12),
    .table thead tr th:nth-child(10),
    .table tbody tr td:nth-child(10) {
        max-width: 200px !important;
        min-width: 150px !important;
        word-break: break-word;
        white-space: normal !important;
        overflow-wrap: anywhere;
    }
    
    /* Optimize column widths for landscape - use flexible widths */
    .table th:nth-child(1),
    .table td:nth-child(1) {
        width: auto; /* Date */
        min-width: 70px;
    }
    
    .table th:nth-child(2),
    .table td:nth-child(2) {
        width: auto; /* Transaction Number */
        min-width: 90px;
    }
    
    .table th:nth-child(3),
    .table td:nth-child(3) {
        width: auto; /* Customer Name - only in main table */
        min-width: 80px;
    }
    
    .table th:nth-child(4),
    .table td:nth-child(4) {
        width: auto; /* Payment Method */
        min-width: 70px;
    }
    
    .table th:nth-child(5),
    .table td:nth-child(5) {
        width: auto; /* Item */
        min-width: 40px;
    }
    
    .table th:nth-child(6),
    .table td:nth-child(6) {
        width: auto; /* Status */
        min-width: 60px;
    }
    
    .table th:nth-child(7),
    .table td:nth-child(7),
    .table th:nth-child(8),
    .table td:nth-child(8),
    .table th:nth-child(9),
    .table td:nth-child(9) {
        width: auto; /* Taxable, Discount, VAT */
        min-width: 60px;
    }
    
    .table th:nth-child(10),
    .table td:nth-child(10) {
        width: auto; /* Total (or Notes in cancelled/refunded) */
        min-width: 60px;
    }
    
    .table th:nth-child(11),
    .table td:nth-child(11) {
        width: auto; /* Cashier - only in main table */
        min-width: 70px;
    }
    
    /* Hide Action column in print */
    .table th:nth-child(13),
    .table td:nth-child(13) {
        display: none !important;
    }
    
    .well {
        font-size: 10px;
        padding: 5px;
        margin: 5px 0;
    }
    
    /* Hide filter inputs in print */
    input[type="date"],
    select.form-control {
        display: none !important;
    }
    
    /* Ensure table fits on page */
    .table-responsive {
        overflow: visible !important;
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/Report/EndDay/transaction.vue